import type { AddressResult, ReverseGeocodeResult } from '../../shared/types/index.js';
import { request } from './client.js';

/** Forward geocoding for the address picker; resolves to an empty list on any failure. */
export async function searchAddresses(q: string): Promise<Array<AddressResult>> {
  try {
    return await request<Array<AddressResult>>('/address/search', { query: { q } });
  } catch {
    return [];
  }
}

export function searchAddressByCoords(lat: number, lng: number): Promise<ReverseGeocodeResult> {
  return request<ReverseGeocodeResult>('/address/by_coordinates', { query: { lat, lng } });
}
